import { useTranslation } from "react-i18next";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

// Accessing kubernetes deployment constants from config.json
import { useContext, useEffect, useRef } from "react";
import ConfigContext from '../../context/configContext';


import "./TransferSubmitted.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppSelector } from "../../hooks/redux-hooks/hooks";
import { Button, Col, Container, Row } from "react-bootstrap";
import TagManager from "react-gtm-module";
import ReactToPrint from "react-to-print";

const TransferSubmittedPage = () => {
  const config = useContext(ConfigContext);
  const { t } = useTranslation();
  const formState = useAppSelector((state) => state.formData.value);
  const { provider, landline, deviceType } = formState ?? {};
  const ref: any = useRef<HTMLDivElement>();

  const isMajorProvider = provider && (
    provider.toLowerCase() === "verizon" ||
    provider.toLowerCase() === "at&t" ||
    provider.toLowerCase() === "consumer cellular" ||
    provider.toLowerCase() === "t-mobile"
  );

  const providerData = formState ? { provider: formState.provider, landline: formState.landline } : {};

  const phoneType = t("transfer_submitted.jitterbug");
  const numDays = isMajorProvider
    ? formState.landline
      ? t("transfer_submitted.land_days")
      : t("transfer_submitted.major_cell_days")
    : t("transfer_submitted.land_days");

  const isSim = deviceType === "sim";
  const isLandline = !!formState.landline;

  let transferDaysMessage = "";

  if (!isLandline && !isMajorProvider) {
    transferDaysMessage = isSim
      ? t("transfer_submitted.phone_transfer_days_for_sim_non_major_providers")
      : t("transfer_submitted.phone_transfer_days_for_non_major_providers", { phone: phoneType });
  } else if (isSim) {
    transferDaysMessage = t("transfer_submitted.phone_transfer_days_for_sim_major_providers", {
      device: isLandline ? "landline" : "",
    });
  } else {
    transferDaysMessage = t("transfer_submitted.phone_transfer_days_for_major_providers", {
      device: deviceType.toLowerCase() === "smart" ? "Smart" : "Flip",
      numDays,
    });
  }

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: "porting_event",
        event_name: "transfer submitted",
        form_name: "Porting",
        form_step: "transfer submitted"
      },
    });

    TagManager.dataLayer({
      dataLayer: {
        event: "form_complete",
        form_name: "Porting"
      },
    });
  }, []);

  return (
    <>
      <Container ref={ref} fluid className="review-phone-container flex-grow-1 h-100">
        <Container fluid className="review-phone-content">
          <Container fluid className="back-container px-0">
            <Row>
              <Col onClick={() => {
                TagManager.dataLayer({
                  dataLayer: {
                    event: "porting_event",
                    event_name: "back_to_acct_overview"
                  },
                });
                                
                window.open(
                  `${config.ACCT_MGT_PORTING_FRONTEND}/myaccount/accountoverview`,
                  "_self"
                );
              }}>
                <FontAwesomeIcon icon={faArrowLeft} />{" "}
                {t("header.back_to_account_overview")}
              </Col>
            </Row>
          </Container>

          <Container fluid className="title-container">
            <Row>
              <Col className="px-0">
                {t("transfer_submitted.transfer_submitted")}
              </Col>
            </Row>
          </Container>

          <Row className="transfer-phone-header-main-divider mx-0">
          </Row>

          <Container fluid className="review-phone-section p-4">
            <Row className="mb-3">
              <Col className="fs-2 fw-bold">
                {t("transfer_submitted.transfer_pending")}
              </Col>
            </Row>
            <Row>
              <Col className="me-3 pe-3">
                <Row className="mb-3">
                  <Col className="fw-bold">
                    {transferDaysMessage}
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col>
                    {t("transfer_submitted.important_message")}
                    <span>
                      {t("transfer_submitted.important_message_2")}
                    </span>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col>
                    <Row>
                      <b>{t("transfer_submitted.next_steps")}</b>
                    </Row>

                    <Row>
                      <Col>
                        <ol>
                          <li className="transfer-submitted-list">
                            {t("transfer_submitted.next_steps_print_instructions")}
                          </li>
                          {
                            isSim ? (
                                <>
                                <li className="transfer-submitted-list">
                                  <span>
                                  {t("transfer_submitted.next_steps_instruction_2_sim")}
                                  </span>
                                </li>
                                <li className="transfer-submitted-list">
                                  <span>
                                  {t("transfer_submitted.next_steps_instruction_3_sim")}
                                  </span>
                                </li>
                                </>
                            ) : (
                              <>
                                <li className="transfer-submitted-list">
                                  {providerData.landline ? (
                                    <span>
                                {t(
                                  "transfer_submitted.next_steps_instruction_2_landline"
                                )}
                                    </span>
                                  ) : (
                                    <span>
                                {t(
                                  "transfer_submitted.next_steps_instruction_2_cell"
                                )}
                                    </span>
                                  )}
                                </li>
                                <li className="transfer-submitted-list">
                            {t("transfer_submitted.next_steps_instruction_2")}
                            <ul className="transfer-submitted-bullet-list "> 
                              <li className="transfer-submitted-list">
                                {t("transfer_submitted.next_steps_instruction_3")}</li>
                              <li className="transfer-submitted-list">
                                {t("transfer_submitted.next_steps_instruction_4")}</li>
                            </ul>                     
                                </li>
                              </>
                            )
                          }

                          
                          {formState.deviceType === "smart" && (
                            <li className="transfer-submitted-list">
                              {t("transfer_submitted.next_steps_instruction_4_smart")}
                            </li>
                          )}
                        </ol>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <Row className="mb-2">
                  <Col>
                    {t("transfer_submitted.check_faq_1")}
                      <a className="check-faq-link" href= {`${config.ACCT_MGT_PORTING_FRONTEND}/myaccount/accountoverview`} target="_self">
                        <strong>Account Overview </strong>
                      </a>
                    {t("transfer_submitted.check_faq_2")}
                      <a className="check-faq-link" href="https://www.lively.com/keep-number" target="_blank">
                        <strong>number transfer FAQs.</strong>
                      </a>
                  </Col>
                </Row>
              </Col>


              {/* transfer info col section */}
              {formState.eligibilityNumber && <Col xs="auto" md="auto" lg="auto" xl="auto">
                <Container fluid className="transfer-info">
                  <Row className="my-3 fw-bold fs-5">
                      <Col>
                      {t("transfer_submitted.transfer_info")}
                      </Col>  
                  </Row>

                  <Row className="mb-2">
                    <Col>
                      <b>{t("review_phone.phoneNumber")}:</b>{" "}
                      <span className="dd-privacy-mask">{formState.eligibilityNumber}</span>
                    </Col>
                  </Row>

                  <Row className="mb-2">
                    <Col>
                      <b>{t("review_phone.carrier")}:</b>{" "}
                      <span className="dd-privacy-mask">{formState.provider.toLowerCase() === "zzz_other"
                        ? formState.inputProvider
                        : formState.provider}</span>
                    </Col>
                  </Row>

                  <Row className="mb-2">
                    <Col>
                      <b>{t("review_phone.primaryAccountHolder")}:</b>{" "}
                      <span className="dd-privacy-mask">{formState.primaryAccountHolder
                        ? t("transfer_phone.primaryAccountHolderYes")
                        : t("transfer_phone.primaryAccountHolderNo")}</span>
                    </Col>
                  </Row>

                  <Row className="mb-2">
                    <Col>
                      <b>{t("review_phone.name")}:</b>{" "}
                      <span className="dd-privacy-mask">{`${formState.firstName} ${formState.lastName}`}</span>
                    </Col>
                  </Row>


                  <Row className="mb-2">
                    <Col>
                      <b>{t("review_phone.billingAddress1")}:</b>{" "}
                      <span className="dd-privacy-mask">{formState.billingAddress}</span>
                    </Col>
                  </Row>

                  <Row className="mb-2">
                    <Col>
                      <b>{t("review_phone.billingAddress2")}:</b>{" "}
                      <span className="dd-privacy-mask">{formState.billingAddress2}</span>
                    </Col>
                  </Row>

                  <Row className="mb-2">
                    <Col>
                      <b>{t("review_phone.city")}:</b> <span className="dd-privacy-mask">{formState.city}</span>
                    </Col>
                  </Row>

                  <Row className="mb-2">
                    <Col>
                      <b>{t("review_phone.state")}:</b> <span className="dd-privacy-mask">{formState.state}</span>
                    </Col>
                  </Row>

                  <Row className="mb-2">
                    <Col>
                      <b>{t("review_phone.zipCode")}:</b> <span className="dd-privacy-mask">{formState.zip}</span>
                    </Col>
                  </Row>

                  <Row className="mb-2">
                    <Col>
                      <b>{t("review_phone.accountNumber")}:</b>{" "}
                      <span className="dd-privacy-mask">{formState.accountNumber}</span>
                    </Col>
                  </Row>

                  <Row className="mb-5">
                    <Col>
                      <b>{t("review_phone.accountTransferPIN")}:</b>{" "}
                      <span className="dd-privacy-mask">{formState.accountPIN}</span>
                    </Col>
                  </Row>
                </Container>
              </Col>}
            </Row>

            <Row className="mt-4">
                  <Col className="mt-1" xs="auto" sm="auto">
                    <ReactToPrint
                      bodyClass="print-agreement"
                      content={() => ref.current}
                      trigger={() => (
                        <Button
                          className="button-secondary review-phone-button-edit-info">
                          {t("transfer_submitted.print")}
                        </Button>
                      )}
                    />
                  </Col>
                </Row>
          </Container>
        </Container>
      </Container>
    </>
  );
};

export default TransferSubmittedPage;
